// React&NextJS
import React from 'react'
// Styles
import s from './DefaultBio.module.scss'
import { Text } from '../../core/text/Text'
import { Button } from '../../core/button/Button'
import Link from 'next/link'

type Props = {
    owner?: boolean
    mid?: string
    [key: string]: unknown
}

export const DefaultBio = ({ owner, mid }: Props) => {
    return (
        <div className={s.default_card}>
            <div>
                <Text variant="h6">
                    {owner
                        ? 'Skrifa æviágrip'
                        : 'Æviágrip hefur ekki verið skrifað'}
                </Text>
                <Text className={s.default_card__bioText} variant="p">
                    Í æviágripi er gefin innsýn í hvernig manneskja hinn látni
                    var, ævistarf og önnur tímamót á ævi hennar.{' '}
                    <Link
                        legacyBehavior
                        passHref
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/advice/hvernig-skrifa-a-gott-aeviagrip"
                    >
                        Hvernig skrifa ég gott æviágrip?
                    </Link>
                </Text>
            </div>
            {owner && (
                <div className={s.default_card__button}>
                    <Button variant="ghost" to={`/account/memories/${mid}`}>
                        Skrifa æviágrip
                    </Button>
                </div>
            )}
        </div>
    )
}
